export var productsData = [
    {
        _id: 1,
        title: "Fjallraven - Foldsack No. 1 Backpack, Fits 15 Laptops",
        salePrice: 109.95,
        regularPrice: 120,
        description: "Your perfect pack for everyday use and walks in the forest. Stash your laptop (up to 15 inches) in the padded sleeve, your everyday",
        category: "men's clothing",
        rating: {
            rate: 3.9,
            reviews: 120
        },
        discount: 20,
        new: false,
        stock: 30,
        inStock: true,
        image: "products/backpack.jpg",
    },
    {
        _id: 2,
        title: "Mens Casual Premium Slim Fit T-Shirts",
        salePrice: 22.3,
        regularPrice: null,
        description: "Slim-fitting style, contrast raglan long sleeve, three-button henley placket, light weight & soft fabric for breathable and comfortable wearing. And Solid stitched shirts with round neck made for durability and a great fit for casual fashion wear and diehard baseball fans. The Henley style round neckline includes a three-button placket.",
        category: "men's clothing",
        rating: {
            rate: 4.1,
            reviews: 259,
        },
        colours: ["black", "blue", "red"],
        sizes: ["XS", "S", "M", "L", "XL"],
        discount: null,
        new: false,
        stock: 30,
        inStock: true,
        image: "products/tshirt-white.jpg",
    },
    {
        _id: 3,
        title: "Mens Cotton Jacket",
        salePrice: 55.99,
        regularPrice: null,
        description: "great outerwear jackets for Spring/Autumn/Winter, suitable for many occasions, such as working, hiking, camping, mountain/rock climbing, cycling, traveling or other outdoors. Good gift choice for you or your family member. A warm hearted love to Father, husband or son in this thanksgiving or Christmas Day.",
        category: "men's clothing",
        rating: {
            rate: 4.7,
            reviews: 500,
        },
        colours: ["black", "blue", "red"],
        sizes: ["XS", "S", "M", "L", "XL"],
        discount: null,
        new: false,
        stock: 30,
        inStock: false,
        image: "products/jacket-brown.jpg",
    },
    {
        _id: 4,
        title: "Mens Casual Slim Fit",
        salePrice: 15.99,
        regularPrice: null,
        description: "The color could be slightly different between on the screen and in practice. / Please note that body builds vary by person, therefore, detailed size information should be reviewed below on the product description.",
        category: "men's clothing",
        rating: {
            rate: 2.1,
            reviews: 430,
        },
        colours: ["black", "blue", "red"],
        sizes: ["XS", "S", "M", "L", "XL"],
        discount: null,
        new: false,
        stock: 30,
        inStock: false,
        image: "products/shirt-blue.jpg",
    },
    {
        _id: 5,
        title: "John Hardy Women's Legends Naga Gold & Silver Dragon Station Chain Bracelet",
        salePrice: 695,
        regularPrice: null,
        description: "From our Legends Collection, the Naga was inspired by the mythical water dragon that protects the ocean's pearl. Wear facing inward to be bestowed with love and abundance, or outward for protection.",
        category: "jewlery",
        rating: {
            rate: 4.6,
            reviews: 400,
        },
        discount: null,
        new: false,
        stock: 30,
        inStock: false,
        image: "products/bracelet-dragon.jpg",
    },
    {
        _id: 6,
        title: "Solid Gold Petite Micropave",
        salePrice: 168,
        regularPrice: null,
        description: "Satisfaction Guaranteed. Return or exchange any order within 30 days.Designed and sold by Hafeez Center in the United States. Satisfaction Guaranteed. Return or exchange any order within 30 days.",
        category: "jewlery",
        rating: {
            rate: 3.9,
            reviews: 70,
        },
        discount: null,
        new: false,
        stock: 30,
        inStock: true,
        image: "products/ring-silver.jpg",
    },
    {
        _id: 7,
        title: "White Gold Plated Princess",
        salePrice: 9.99,
        regularPrice: null,
        description: "Classic Created Wedding Engagement Solitaire Diamond Promise Ring for Her. Gifts to spoil your love more for Engagement, Wedding, Anniversary, Valentine's Day...",
        category: "jewlery",
        rating: {
            rate: 3,
            reviews: 400,
        },
        discount: null,
        new: false,
        stock: 30,
        inStock: false,
        image: "products/ring-diamond.jpg",
    },
    {
        _id: 8,
        title: "Pierced Owl Rose Gold Plated Stainless Steel Double",
        salePrice: 10.99,
        regularPrice: null,
        description: "Rose Gold Plated Double Flared Tunnel Plug Earrings. Made of 316L Stainless Steel",
        category: "jewlery",
        rating: {
            rate: 1.9,
            reviews: 100,
        },
        discount: null,
        new: false,
        stock: 30,
        inStock: false,
        image: "products/rings2.jpg",
    },
    {
        _id: 9,
        title: "WD 2TB Elements Portable External Hard Drive - USB 3.0",
        salePrice: 64,
        regularPrice: 75,
        description: "USB 3.0 and USB 2.0 Compatibility Fast data transfers Improve PC Performance High Capacity; Compatibility Formatted NTFS for Windows 10, Windows 8.1, Windows 7; Reformatting may be required for other operating systems; Compatibility may vary depending on user’s hardware configuration and operating system",
        category: "electronics",
        rating: {
            rate: 3.3,
            reviews: 203,
        },
        discount: 40,
        new: false,
        stock: 30,
        inStock: false,
        image: "products/ext-hard-drive.jpg",
    },
    {
        _id: 10,
        title: "SanDisk SSD PLUS 1TB Internal SSD - SATA III 6 Gb/s",
        salePrice: 109,
        regularPrice: null,
        description: "Easy upgrade for faster boot up, shutdown, application load and response (As compared to 5400 RPM SATA 2.5” hard drive; Based on published specifications and internal benchmarking tests using PCMark vantage scores) Boosts burst write performance, making it ideal for typical PC workloads The perfect balance of performance and reliability Read/write speeds of up to 535MB/s/450MB/s (Based on internal testing; Performance may vary depending upon drive capacity, host device, OS and application.)",
        category: "electronics",
        rating: {
            rate: 2.9,
            reviews: 470,
        },
        discount: null,
        new: true,
        stock: 30,
        inStock: false,
        image: "products/sandisk-ssd.jpg",
    },
    {
        _id: 11,
        title: "Silicon Power 256GB SSD 3D NAND A55 SLC Cache Performance Boost SATA III 2.5",
        salePrice: 109,
        regularPrice: 130,
        description: "3D NAND flash are applied to deliver high transfer speeds Remarkable transfer speeds that enable faster bootup and improved overall system performance. The advanced SLC Cache Technology allows performance boost and longer lifespan 7mm slim design suitable for Ultrabooks and Ultra-slim notebooks. Supports TRIM command, Garbage Collection technology, RAID, and ECC (Error Checking & Correction) to provide the optimized performance and enhanced reliability.",
        category: "electronics",
        rating: {
            rate: 4.8,
            reviews: 319,
        },
        discount: 15,
        new: false,
        stock: 30,
        inStock: false,
        image: "products/silicon-ssd.jpg",
    },
    {
        _id: 12,
        title: "WD 4TB Gaming Drive Works with Playstation 4 Portable External Hard Drive",
        salePrice: 114,
        regularPrice: null,
        description: "Expand your PS4 gaming experience, Play anywhere Fast and easy, setup Sleek design with high capacity, 3-year manufacturer's limited warranty",
        category: "electronics",
        rating: {
            rate: 4.8,
            reviews: 400,
        },
        discount: null,
        new: false,
        stock: 30,
        inStock: false,
        image: "products/gaming-drive.jpg",
    },
    {
        _id: 13,
        title: "Acer SB220Q bi 21.5 inches Full HD (1920 x 1080) IPS Ultra-Thin",
        salePrice: 599,
        regularPrice: null,
        description: "21. 5 inches Full HD (1920 x 1080) widescreen IPS display And Radeon free Sync technology. No compatibility for VESA Mount Refresh Rate: 75Hz - Using HDMI port Zero-frame design | ultra-thin | 4ms response time | IPS panel Aspect ratio - 16: 9. Color Supported - 16. 7 million colors. Brightness - 250 nit Tilt angle -5 degree to 15 degree. Horizontal viewing angle-178 degree. Vertical viewing angle-178 degree 75 hertz",
        category: "electronics",
        rating: {
            rate: 2.9,
            reviews: 250,
        },
        discount: null,
        new: false,
        stock: 30,
        inStock: false,
        image: "products/screen-acer.jpg",
    },
    {
        _id: 14,
        title: "Samsung 49-Inch CHG90 144Hz Curved Gaming Monitor (LC49HG90DMNXZA) – Super Ultrawide Screen QLED",
        salePrice: 999.99,
        regularPrice: 1200,
        description: "49 INCH SUPER ULTRAWIDE 32:9 CURVED GAMING MONITOR with dual 27 inch screen side by side QUANTUM DOT (QLED) TECHNOLOGY, HDR support and factory calibration provides stunningly realistic and accurate color and contrast 144HZ HIGH REFRESH RATE and 1ms ultra fast response time work to eliminate motion blur, ghosting, and reduce input lag",
        category: "electronics",
        rating: {
            rate: 2.2,
            reviews: 140,
        },
        discount: 25,
        new: false,
        stock: 30,
        inStock: false,
        image: "products/screen-samsung.jpg",
    },
    {
        _id: 15,
        title: "BIYLACLESEN Women's 3-in-1 Snowboard Jacket Winter Coats",
        salePrice: 56.99,
        regularPrice: null,
        description: "Note:The Jackets is US standard size, Please choose size as your usual wear Material: 100% Polyester; Detachable Liner Fabric: Warm Fleece. Detachable Functional Liner: Skin Friendly, Lightweigt and Warm.Stand Collar Liner jacket, keep you warm in cold weather. Zippered Pockets: 2 Zippered Hand Pockets, 2 Zippered Pockets on Chest (enough to keep cards or keys)and 1 Hidden Pocket Inside.Zippered Hand Pockets and Hidden Pocket keep your things secure. Humanized Design: Adjustable and Detachable Hood and Adjustable cuff to prevent the wind and water,for a comfortable fit. 3 in 1 Detachable Design provide more convenience, you can separate the coat and inner as needed, or wear it together. It is suitable for different season and help you adapt to different climates",
        category: "women's clothing",
        rating: {
            rate: 2.6,
            reviews: 235,
        },
        colours: ["black", "blue", "red"],
        sizes: ["XS", "S", "M", "L", "XL"],
        discount: null,
        new: false,
        stock: 30,
        inStock: true,
        image: "products/jacket-violet.jpg",
    },
    {
        _id: 16,
        title: "Lock and Love Women's Removable Hooded Faux Leather Moto Biker Jacket",
        salePrice: 29.95,
        regularPrice: null,
        description: "100% POLYURETHANE(shell) 100% POLYESTER(lining) 75% POLYESTER 25% COTTON (SWEATER), Faux leather material for style and comfort / 2 pockets of front, 2-For-One Hooded denim style faux leather jacket, Button detail on waist / Detail stitching at sides, HAND WASH ONLY / DO NOT BLEACH / LINE DRY / DO NOT IRON",
        category: "women's clothing",
        rating: {
            rate: 2.9,
            reviews: 340,
        },
        colours: ["black", "blue", "red"],
        sizes: ["XS", "S", "M", "L", "XL"],
        discount: null,
        new: true,
        stock: 30,
        inStock: true,
        image: "products/jacket-black.jpg",
    },
    {
        _id: 17,
        title: "Rain Jacket Women Windbreaker Striped Climbing Raincoats",
        salePrice: 39.99,
        regularPrice: 55,
        description: "Lightweight perfet for trip or casual wear---Long sleeve with hooded, adjustable drawstring waist design. Button and zipper front closure raincoat, fully stripes Lined and The Raincoat has 2 side pockets are a good size to hold all kinds of things, it covers the hips, and the hood is generous but doesn't overdo it.Attached Cotton Lined Hood with Adjustable Drawstrings give it a real styled look.",
        category: "women's clothing",
        rating: {
            rate: 3.8,
            reviews: 679,
        },
        colours: ["black", "blue", "red"],
        sizes: ["XS", "S", "M", "L", "XL"],
        discount: 35,
        new: false,
        stock: 30,
        inStock: true,
        image: "products/coat-blue.jpg",
    },
    {
        _id: 18,
        title: "MBJ Women's Solid Short Sleeve Boat Neck V",
        salePrice: 9.85,
        regularPrice: null,
        description: "95% RAYON 5% SPANDEX, Made in USA or Imported, Do Not Bleach, Lightweight fabric with great stretch for comfort, Ribbed on sleeves and neckline / Double stitching on bottom hem",
        category: "women's clothing",
        rating: {
            rate: 4.7,
            reviews: 130,
        },
        colours: ["black", "blue", "red"],
        sizes: ["XS", "S", "M", "L", "XL"],
        discount: null,
        new: false,
        stock: 30,
        inStock: true,
        image: "products/shirt-women.jpg",
    },
    {
        _id: 19,
        title: "Opna Women's Short Sleeve Moisture",
        salePrice: 7.95,
        regularPrice: null,
        description: "100% Polyester, Machine wash, 100% cationic polyester interlock, Machine Wash & Pre Shrunk for a Great Fit, Lightweight, roomy and highly breathable with moisture wicking fabric which helps to keep moisture away, Soft Lightweight Fabric with comfortable V-neck collar and a slimmer fit, delivers a sleek, more feminine silhouette and Added Comfort",
        category: "women's clothing",
        rating: {
            rate: 4.5,
            reviews: 146,
        },
        colours: ["black", "blue", "red"],
        sizes: ["XS", "S", "M", "L", "XL"],
        discount: null,
        new: false,
        stock: 30,
        inStock: true,
        image: "products/shirt-women-red.jpg",
    },
    {
        _id: 20,
        title: "DANVOUY Womens T Shirt Casual Cotton Short",
        salePrice: 12.99,
        regularPrice: 15,
        description: "95%Cotton,5%Spandex, Features: Casual, Short Sleeve, Letter Print,V-Neck,Fashion Tees, The fabric is soft and has some stretch., Occasion: Casual/Office/Beach/School/Home/Street. Season: Spring,Summer,Autumn,Winter.",
        category: "women's clothing",
        rating: {
            rate: 3.6,
            reviews: 145,
        },
        colours: ["black", "blue", "red"],
        sizes: ["XS", "S", "M", "L", "XL"],
        discount: 25,
        new: false,
        stock: 30,
        inStock: true,
        image: "products/tshirt-women.jpg",
    },
]